// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H14V10H22V22H16V16H14V22H2V2ZM8 10H12V4H4V20H8V10Z"}}]};

const City7FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'city-7-filled',
    ref,
    icon: element,
  },
));

City7FilledIcon.displayName = 'City7FilledIcon';

export default City7FilledIcon;
